import { render, staticRenderFns } from "./ExhibitBlockLayout.vue?vue&type=template&id=0894264c&scoped=true&"
import script from "./ExhibitBlockLayout.vue?vue&type=script&lang=js&"
export * from "./ExhibitBlockLayout.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitBlockLayout.vue?vue&type=style&index=0&id=0894264c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894264c",
  null
  
)

export default component.exports